import React from "react";
import {
  Paper,Table,TableBody,TableCell,TableContainer,TableHead,TablePagination,TableRow
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { convertDateInStandardFormat } from "../../../utils/formatting/date";
const StyledTableCell = styled(TableCell)({
  "&.MuiTableCell-root": {
    fontWeight: "bold",
  },
});
export default function OrganisationListingTable(props) {
  const {
    page,
    rowsPerPage,
    totalRecords,
    handlePageChange,
    handleRowsPerPageChange,
  } = props;
  const navigate = useNavigate();
  const onPageChange = (event, newPage) => {
    handlePageChange(newPage);
  };
  const onRowsPerPageChange = (event) => {
    handleRowsPerPageChange(parseInt(event.target.value, 10));
    handlePageChange(0);
  };
  const renderColumn = (row, column) => {
    switch (column.id) {
      case "_id":
        return (
          <>
            <span>{row._id}</span>
          </>
        );
      case "name":
        return (
          <>
            <span>{row.name}</span>
          </>
        );
      case "createdAt":
        return (
          <>
            <span>{convertDateInStandardFormat(row.createdAt)}</span>
          </>
        );
      case "updatedAt":
        return (
          <>
            <span>{convertDateInStandardFormat(row.updatedAt)}</span>
          </>
        );
      default:
        break;
    }
  };

  return (
    <Paper sx={{width: "100%", overflow: "hidden"}}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {props.columns.map((column) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    backgroundColor: "#4B92E7",
                    color: "#fff",
                  }}
                  className="font-medium"
                >
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.length > 0 ? (
              props?.data?.map((row, index) => {
                return (
                  <TableRow
                    style={{cursor: "pointer"}}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={index}
                  >
                    {props.columns.map((column, idx) => {
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {renderColumn(row, column)}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })) : (
              <TableRow>
                <TableCell colSpan={props.columns.length + 2} align="center">
                  <lable className="text-sm">
                    No data to display
                  </lable>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalRecords}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </Paper>
  );
}
